// extracted by mini-css-extract-plugin
export default {"StyleSelector":"styles_StyleSelector__6+P3h","button":"styles_button__geQs9","active":"styles_active__Ao-M2"};